import { createFileRoute, Navigate } from "@tanstack/react-router";
import { routePath } from "#app/lib/hooks/use-app-navigate";

/**
 * `/settings/updates` — kept only to forward to Outcomes, which absorbed this
 * page and the Reasons sub-page it linked to. The sidebar row and every
 * in-app link point at the new route; this survives for links already out in
 * the world (a bookmark, a shared URL, a support reply).
 */
function UpdatesRedirect() {
  const { workspace } = Route.useParams();
  return <Navigate to={routePath(`/${workspace}/settings/outcomes`)} replace />;
}

export const Route = createFileRoute("/(app)/$workspace/settings/updates")({
  component: UpdatesRedirect,
});
